import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'

export const CaseNumberIconWrapper = styled('span')<{ theme?: TTheme }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-left: 4px;
  svg {
    display: block;
    color: ${({ theme }) => theme.colors.greys[500]};
    transition: color 0.2s ease-in-out;
    :hover {
      color: ${({ theme }) => theme.colors.greys[600]};
      transition: color 0.2s ease-in-out;
    }
  }
`
export const CaseNumberRow = styled('span')`
  display: flex;
  align-items: center;
  gap: 8px;
`
